import React, { useState, useEffect } from "react";
import { fetchWithAuth } from "../../utils/fetchWithAuth";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

export function ShareModal({ theme: t, activeTab, onClose }) {
  const [shares,  setShares]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [msg,     setMsg]     = useState("");
  const [form,    setForm]    = useState({ title: `${activeTab} view`, expiresIn: "", });
  const [copied,  setCopied]  = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await fetchWithAuth(`${API}/api/share`);
        if (res.ok) setShares(await res.json());
      } catch {}
      setLoading(false);
    })();
  }, []);

  async function handleCreate() {
    if (!form.title.trim()) { setMsg("⚠️ Title is required"); return; }
    setSaving(true);
    try {
      const res = await fetchWithAuth(`${API}/api/share`, {
        method: "POST",
        body: JSON.stringify({ title: form.title, tab: activeTab, expiresIn: form.expiresIn ? parseInt(form.expiresIn, 10) : undefined }),
      });
      const d = await res.json();
      if (!res.ok) { setMsg(`⚠️ ${d.error}`); setSaving(false); return; }
      setShares(s => [...s, d]);
      setMsg("✓ Share link created.");
      setForm({ title: `${activeTab} view`, expiresIn: "" });
    } catch { setMsg("⚠️ Network error"); }
    setSaving(false);
  }

  async function handleRevoke(token) {
    try {
      const res = await fetchWithAuth(`${API}/api/share/${token}`, { method: "DELETE" });
      if (!res.ok) throw new Error((await res.json()).error);
      setShares(s => s.filter(x => x.token !== token));
      setMsg("✓ Link revoked.");
    } catch (e) { setMsg(`⚠️ ${e.message}`); }
  }

  function copyLink(token) {
    const url = `${window.location.origin}/shared/${token}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(token);
      setTimeout(() => setCopied(""), 2000);
    });
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000bb", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: 20, width: "100%", maxWidth: 520, maxHeight: "80vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px #00000055" }}>
        <div style={{ padding: "18px 22px 14px", borderBottom: `1px solid ${t.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: t.text, fontFamily: "Georgia, serif" }}>Share Dashboard View</div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: t.textMuted, cursor: "pointer", fontSize: 20 }}>×</button>
        </div>

        <div style={{ padding: "16px 22px", borderBottom: `1px solid ${t.border}` }}>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: 10, color: t.textMuted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 5, fontWeight: 700 }}>Link Title</label>
              <input value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))}
                style={{ width: "100%", background: t.surface2, border: `1px solid ${t.border}`, borderRadius: 8, padding: "8px 12px", color: t.text, fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ width: 120 }}>
              <label style={{ display: "block", fontSize: 10, color: t.textMuted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 5, fontWeight: 700 }}>Expires (days)</label>
              <input type="number" min="1" max="365" value={form.expiresIn} onChange={e => setForm(p => ({ ...p, expiresIn: e.target.value }))}
                placeholder="Never"
                style={{ width: "100%", background: t.surface2, border: `1px solid ${t.border}`, borderRadius: 8, padding: "8px 12px", color: t.text, fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>
          </div>
          {msg && <div style={{ fontSize: 12, color: msg.startsWith("✓") ? "#22c55e" : "#DC2626", marginTop: 8 }}>{msg}</div>}
          <button onClick={handleCreate} disabled={saving}
            style={{ marginTop: 12, background: "#2563EB", border: "none", borderRadius: 8, padding: "9px 18px", color: "#fff", fontSize: 13, fontWeight: 800, cursor: saving ? "default" : "pointer", fontFamily: "Georgia, serif" }}>
            {saving ? "Creating…" : "Create Link"}
          </button>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "12px 22px" }}>
          <div style={{ fontSize: 11, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.8, fontWeight: 700, marginBottom: 10 }}>Your Links ({shares.length}/20)</div>
          {loading && <div style={{ color: t.textFaint, fontSize: 13 }}>Loading…</div>}
          {!loading && shares.length === 0 && <div style={{ color: t.textFaint, fontSize: 13 }}>No links yet.</div>}
          {!loading && shares.map(s => (
            <div key={s.token} style={{ background: t.surface2, border: `1px solid ${t.border}`, borderRadius: 10, padding: "10px 14px", marginBottom: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: t.text, marginBottom: 2 }}>{s.title}</div>
                  <div style={{ fontSize: 10, color: t.textFaint }}>
                    {s.tab} · Created {new Date(s.createdAt).toLocaleDateString()}
                    {s.expiresAt ? ` · Expires ${new Date(s.expiresAt).toLocaleDateString()}` : " · Never expires"}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
                  <button onClick={() => copyLink(s.token)}
                    style={{ background: copied === s.token ? "#22c55e" : "none", border: `1px solid ${copied === s.token ? "#22c55e" : t.border}`, borderRadius: 6, padding: "3px 10px", color: copied === s.token ? "#fff" : t.textSub, fontSize: 11, cursor: "pointer" }}>
                    {copied === s.token ? "Copied!" : "Copy"}
                  </button>
                  <button onClick={() => handleRevoke(s.token)}
                    style={{ background: "none", border: "1px solid #DC262633", borderRadius: 6, padding: "3px 10px", color: "#DC2626", fontSize: 11, cursor: "pointer" }}>
                    Revoke
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
